import React from "react";
import ReactDOM from "react-dom";
import App from "./components";
import { ThemeProvider } from "@material-ui/styles";
//import { MuiPickersUtilsProvider } from "@material-ui/pickers";
//import DateFnsUtils from "@date-io/date-fns";
import theme from "./theme.js";
import PrintContainer from "./components/print";
import "./assets/css/styles.css";
import { Provider } from "mobx-react";
import store from "./store";

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      {store.$router.key2 === "print" ? <PrintContainer /> : <App />}
    </ThemeProvider>
  </Provider>,
  document.getElementById("root")
);

function noop() {}

if (process.env.NODE_ENV !== "development") {
  console.log = noop;
  console.warn = noop;
  console.error = noop;
}
